import Radio from 'backbone.radio'

export default Radio.channel('nav')
